import {DeliveryCycleNumberType, RecurringPaymentsSearchType} from 'supporter';
import { makeFastFuncOfGetI18n } from '@/utils/i18n';
import { CompSelectBoxOption } from '@/components/common/CompSelectBox.vue';

interface DeliveryCycleOptions {
	name: string,
	hasAll: boolean,
	noBrackets: boolean,
	data: {id: string; value: 'ALL' | DeliveryCycleNumberType; dispaly: string}[] // CheckBoxComponent 에서 dispaly 라고 명시했기 때문에 어쩔 수 없다...
}


export interface SearchFormOptions {
	searchKeywordTypes: CompSelectBoxOption<RecurringPaymentsSearchType>[];
	periodOption: {
		name: string;
		periodTypes: string[];
		period: string;
	}
	deliveryCycleOptions: DeliveryCycleOptions;
}

export const getI18nOfThis = makeFastFuncOfGetI18n('RECURRINGPAYMENTS_ORDER');
// 고정된 체크박스 옵션들이나 select 옵션들
export const options = (options?: {
	periodInPeriodOption?: string;
}): SearchFormOptions => (
	{
		// 검색어 타입
		searchKeywordTypes: [
			{
				value: 'PRODUCT_NAME',
				name: window.$t('COMMON_PRODUCT_NAME'),
			},
			{
				value: 'PRODUCT_NO',
				name: window.$t('COMMON_PRODUCT_NO'),
			},
			{
				value: 'MEMBER_ID',
				name: window.$t('COMMON_ID'),
			},
			{
				value: 'MEMBER_NAME',
				name: getI18nOfThis('REGISTRANT_NAME'),
			}

		],

		// 신청일 dateCalender 옵션 설정
		periodOption: {
			name: 'registrationDate',
			periodTypes: ['td', '1w', '1m', '3m', '6m', '1y'],
			period: options?.periodInPeriodOption ?? '3m',
		},

		// 배송주기
		deliveryCycleOptions: {
			name: 'deliveryCycleOptions',
			hasAll: true,
			noBrackets: true,
			data: [
				{
					id: 'ALL',
					value: 'ALL',
					dispaly: 'COMMON_ALL_CHECK',
				},
				{
					id: 'ONE_MONTH',
					value: 1,
					dispaly: '1' + window.$t('COMMON_MONTHS'),
				},
				{
					id: 'TWO_MONTH',
					value: 2,
					dispaly: '2' + window.$t('COMMON_MONTHS'),
				},
				{
					id: 'THREE_MONTH',
					value: 3,
					dispaly: '3' + window.$t('COMMON_MONTHS'),
				},
				{
					id: 'FOUR_MONTH',
					value: 4,
					dispaly: '4' + window.$t('COMMON_MONTHS'),
				},
				{
					id: 'FIVE_MONTH',
					value: 5,
					dispaly: '5' + window.$t('COMMON_MONTHS'),
				},
				{
					id: 'SIX_MONTH',
					value: 6,
					dispaly: '6' + window.$t('COMMON_MONTHS'),
				},
			]
		},
	})

export const DEFAULT_STATE = {
	searchKeywordType: 'PRODUCT_NAME',
	searchKeywordValue: '',
	deliveryCycles: 'ALL',
} as const;